import { render, staticRenderFns } from "./baseStationTable.vue?vue&type=template&id=1f89c73c&scoped=true&"
import script from "./baseStationTable.vue?vue&type=script&lang=js&"
export * from "./baseStationTable.vue?vue&type=script&lang=js&"
import style0 from "./baseStationTable.vue?vue&type=style&index=0&id=1f89c73c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f89c73c",
  null
  
)

export default component.exports